import React from 'react';
import { useTranslation } from 'react-i18next';

interface CompanySearchProps {
  registrationNumberDisplay: string;
  validationError: string;
  loading: boolean;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onLookupClick: () => void;
}

export const CompanySearchInput = ({
  registrationNumberDisplay,
  validationError,
  loading,
  onSearchChange,
  onLookupClick,
}: CompanySearchProps) => {
  const { t } = useTranslation('AddCompany');

  return (
    <div>
      <p className='mb-2 font-semibold'>{t('lookUpCBE')}</p>
      <div className='relative flex font-semibold'>
        <input
          className={`flex-1 border rounded-l-md px-4 ${validationError ? 'border-red-500' : 'border-gray-300'}`}
          type='text'
          placeholder={t('lookupPlace')}
          value={registrationNumberDisplay}
          onChange={onSearchChange}
        />
        <button
          className='py-3 px-4 rounded-r-md bg-secondary-600 hover:bg-[#C0BF00] text-primary-600 disabled:bg-secondary-400'
          onClick={onLookupClick}
          disabled={loading}
        >
          {loading ? t('fetching') : t('lookupCompany')}
        </button>
      </div>
    </div>
  );
};
